import { Box, Grid, Typography, Theme } from '@mui/material';
import { SubHeading } from '../investors/components';
import React from 'react';
import { Item, ItemDetails, Gridstyles } from './index';
import { Applicant } from '../../redux-store/types/api-types';
import { formatShortDate } from '../../utils/date';
import { SxProps } from '@mui/system';
import {
  applicantStatusMasters,
  maritalStatusMaster,
  ModeOfOperationMaster,
  yesAndNoMasters,
} from '../../utils/constant';
import { ParentDeclaration } from '../investors/contributorDetails';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import { ApplicationSectionHeading } from '../ApplicationSectionHeading';

export const KeyValue = ({
  title,
  description,
  amount,
  sx = {},
  dispalyModifiedIcon = false,
  onInfoClick,
}: {
  title: string | undefined;
  description?: string | number | boolean | null;
  amount?: number | null | undefined | string;
  sx?: SxProps<Theme>;
  dispalyModifiedIcon?: boolean;
  onInfoClick?: any;
}): JSX.Element => {
  return (
    <Grid item xs={12} sm={6}>
      <Item sx={sx}>
        {title}
        {dispalyModifiedIcon && (
          <Typography component="span" sx={{ pl: 1, ':hover': { cursor: 'pointer' } }}>
            <ManageAccountsIcon color="info" fontSize="small" onClick={onInfoClick} />
          </Typography>
        )}{' '}
      </Item>
      <ItemDetails> {description ? description : '-'}</ItemDetails>
      {!!amount && amount !== 0 && <Item sx={{ pt: 0 }}> {amount}</Item>}
    </Grid>
  );
};

export default function ContributorDetails({
  applicants = [],
  modeOfHolding,
  modeOfOperation,
}: {
  applicants: Partial<Applicant>[];
  modeOfHolding: string;
  modeOfOperation: string;
}): JSX.Element {
  return (
    <>
      <Box
        sx={{
          bgcolor: 'white',
          boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.05)',
          borderRadius: '10px',
        }}
        mt={5}>
        <Box sx={{ p: 2 }}>
          <Grid container sx={{ mt: 1, pl: { xs: 2, sm: 10 }, pr: { xs: 2, sm: 10 } }}>
            <Grid container direction="row" justifyContent="space-between" alignItems="flex-start">
              <ApplicationSectionHeading title="Contributor Details" />
              <Typography
                sx={{
                  fontSize: 18,
                  fontWeight: 600,
                  color: 'text.secondary',
                }}>
                Mode of Holding:{' '}
                <Typography
                  component="span"
                  sx={{
                    fontWeight: 500,
                    fontSize: '16px',
                    color: 'rgba(0, 0, 0, 0.6)',
                    letterSpacing: '0.4px',
                    ml: 0.5,
                    textTransform: 'capitalize',
                  }}>
                  {modeOfHolding || 'Single'}
                </Typography>
              </Typography>
            </Grid>
            {applicants.map((applicant, index: number) => {
              const title = [
                'First Applicant Details',
                'Second Applicant Details',
                'Third Applicant Details',
              ][index];
              return (
                <React.Fragment key={applicant.id}>
                  <SubHeading
                    sx={{
                      color: 'common.black',
                      letterSpacing: 0.5 + 'px',
                      padding: { xs: '10px 10px', sm: '10px 30px' },
                    }}>
                    {title}
                  </SubHeading>
                  <Gridstyles>
                    <Grid
                      item
                      container
                      pb={5}
                      rowSpacing={6}
                      columnSpacing={13}
                      direction="row"
                      justifyContent="space-between"
                      alignItems="flex-start">
                      <KeyValue title={'Name'} description={applicant.name} />
                      <KeyValue title={'Gender'} description={applicant.gender} />
                      <KeyValue
                        title={'Date Of Birth'}
                        description={formatShortDate(applicant.dateOfBirth)}
                      />
                      <KeyValue
                        title={'Father/Spouse Name'}
                        description={applicant.fatherOrSpouseName}
                      />
                      <KeyValue title={'Mother Name'} description={applicant.motherName} />
                      <KeyValue title={'PAN'} description={applicant.panNo} />
                      <KeyValue
                        title={'Status'}
                        description={
                          applicant.status
                            ? applicantStatusMasters[applicant.status]
                            : applicant.status
                        }
                      />
                      <KeyValue
                        title={'Marital Status'}
                        description={
                          applicant.maritalStatus
                            ? maritalStatusMaster[applicant.maritalStatus]
                            : applicant.maritalStatus
                        }
                      />
                      <KeyValue title={'Nationality'} description={applicant.nationality} />
                      {index !== 0 && (
                        <KeyValue
                          title={'RelationShip With First Applicant'}
                          description={applicant.relationShipWithFirstApplicant}
                        />
                      )}
                      <KeyValue
                        title={'Aadhar Last 4 Digit'}
                        description={applicant.aadhaarNumber}
                      />
                      <KeyValue
                        title={'Existing Relationship'}
                        description={yesAndNoMasters[applicant.isExistingRelationship || '']}
                      />
                      {yesAndNoMasters[applicant.isExistingRelationship || ''] ===
                        yesAndNoMasters.yes && (
                        <KeyValue
                          title={'Existing Relationship No'}
                          description={applicant.existingRelationshipNo}
                        />
                      )}
                      <KeyValue title={'Parent ID'} description={applicant.parentId} />
                    </Grid>
                    {applicant.parentIdDeclaration && <Typography>{ParentDeclaration}</Typography>}
                  </Gridstyles>
                </React.Fragment>
              );
            })}
            {applicants.length > 1 && (
              <>
                <SubHeading
                  sx={{
                    color: 'common.black',
                    letterSpacing: 0.5 + 'px',
                    padding: { xs: '10px 10px', sm: '10px 30px' },
                  }}>
                  Redeem
                </SubHeading>
                <Gridstyles sx={{ width: '100%' }}>
                  <Grid
                    item
                    container
                    pb={5}
                    rowSpacing={6}
                    columnSpacing={13}
                    direction="row"
                    justifyContent="space-between"
                    alignItems="flex-start">
                    <KeyValue
                      title={'Mode of Operation'}
                      description={ModeOfOperationMaster[modeOfOperation || '']}
                    />
                  </Grid>
                </Gridstyles>
              </>
            )}
          </Grid>
        </Box>
      </Box>
    </>
  );
}
